function __drawShapeByGeoJsonOnMap__(
  draw: any,
  drawId: any,
  geoJson: any,
  map: any = null
) {
  if (!draw || !drawId || !geoJson) {
    return;
  }
  // get previous drawn shapes features and append new into it
  const currentFeatures = draw.getAll();

  const comingFeatures = geoJson?.features.map((f: any) => {
    if (!f.id) {
      f.id =
        "feature#" + Math.random().toString(36).substr(2, 9) + "#" + drawId;
      f.properties = { ...(f.properties || {}), readOnly: true };
    } else if (f.id) {
      f.id = "feature#" + f.id + "#" + drawId;
      f.properties = { ...(f.properties || {}), readOnly: true };
    }

    return f;
  });

  const isFeatureIdPresent = (feature: any, currentFeatures: any) => {
    return currentFeatures.some(
      (currentFeature: any) => currentFeature.id === feature.id
    );
  };

  const uniqueFeatures = comingFeatures.filter(
    (feature: any) => !isFeatureIdPresent(feature, currentFeatures.features)
  );

  currentFeatures.features = [...currentFeatures.features, ...uniqueFeatures];

  draw.set(currentFeatures);
  if (map) {
    map.on("draw.selectionchange", (e: any) => {
      // If any of the newly selected features has our readOnly flag, clear selection:
      if (e.features.some((f: any) => f.properties?.readOnly)) {
        draw.changeMode("simple_select", { featureIds: [] });
      }
    });
  }
}

export { __drawShapeByGeoJsonOnMap__ };
